import React from 'react';
import { observer } from 'mobx-react';
import { IntlShape } from 'react-intl';
import PublishArtifactPopoverVM from './publish-artifact-popover.viewmodel';
import { CommonModal } from '../../../../global/modal/common/common-modal';
import DefaultButton from '../../../../global/default-button/default-button';
import { DefaultCloseModalButton } from '../../../../global/modal/common/common-close-modal-buttons';
import { artifactStatusLabel, artifactStyleByStatus } from '../../../../../constants/artifacts.constants';
import { DateTimeFormatter } from '../../../../../infrastructure/implementations/date-formatter';

import './publish-artifact-popover.scss';
import DateTimeArtifactDetails from './date-time-artifact-details';
import { PreviewKnovioArtifactButton } from '../preview-artifact/preview-knovio-artifact-button';

export interface IPublishArtifactPopoverProps {
    eventTimeZone: string;
    dateTimeFormatter: DateTimeFormatter;
    vm: PublishArtifactPopoverVM;
    intl: IntlShape;
    onOpenKnovioPreviewLinkPopover: (meetingId: number, assetMetadataId: number) => void;
}

const PublishArtifactPopover = observer(({
    vm,
    intl,
    eventTimeZone,
    dateTimeFormatter,
    onOpenKnovioPreviewLinkPopover,
}: IPublishArtifactPopoverProps) => {

    if (!vm?.meetingArtifact) return null;
    const {
        meetingArtifact,
        artifact,
        closePopover,
        onPublishPassportReplayHandler,
        isPopoverOpened
    } = vm;
    const shouldRenderTopicOrPresenters = meetingArtifact.topic || !!meetingArtifact.presenters?.length;
    const shouldRenderMeetingType = meetingArtifact.type;
    const startDateTime = new Date(meetingArtifact.startDateTime);
    const endDateTime = new Date(meetingArtifact.endDateTime);

    return (
        <CommonModal
            className='publish-artifact-modal'
            isOpen={isPopoverOpened}
            title={intl.formatMessage({
                id: 'oe.artifacts.reviewAndPublishPassportReplay',
                defaultMessage: 'Review and Publish Passport Replay',
                description: 'Label text',
            })}
            onRequestClose={closePopover}
            footer={(
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultButton
                        text={intl.formatMessage({
                            id: 'oe.common.publish',
                            defaultMessage: 'Publish',
                            description: 'Label text',
                        })}
                        modifier={['fat', 'confirm-safe']}
                        onClick={() => onPublishPassportReplayHandler(
                            meetingArtifact.meetingId,
                            artifact.assetMetadataId
                        )}
                        dataTestId='publish-passport-replay-artifact'
                    />
                    <DefaultCloseModalButton/>
                </div>
            )}
        >
            <div className='publish-artifact-popover'>
                <div className='publis-artifact-popover-body'>
                    { meetingArtifact.startDateTime &&
                        <DateTimeArtifactDetails
                            startDateTime={startDateTime}
                            endDateTime={endDateTime}
                            eventTimeZone={eventTimeZone}
                            dateTimeFormatter={dateTimeFormatter}
                        />
                    }
                    { shouldRenderTopicOrPresenters &&
                        <div data-test-id='meeting--topic' className='meeting--topic m-bottom-10px m-top-10px'>
                            { meetingArtifact.topic || meetingArtifact.presenters.join(', ') }
                        </div>
                    }
                    { shouldRenderMeetingType &&
                        <div data-test-id='meeting--type' className='meeting--type m-bottom-10px'>
                            { meetingArtifact.type }
                        </div>
                    }
                    <div
                        data-test-id='artifact-status'
                        className={`artifact-status ${artifactStyleByStatus[artifact.assetStatus]}` }
                    >
                        { artifactStatusLabel[artifact.assetStatus] }
                    </div>
                    <div className='publish-artifact-button-container'>
                        <PreviewKnovioArtifactButton
                            onClick={onOpenKnovioPreviewLinkPopover.bind(this, meetingArtifact.meetingId, artifact.assetMetadataId)}
                        />
                    </div>
                </div>
            </div>

        </CommonModal>
    );
});

export default PublishArtifactPopover;

